<template>
    <div class="home">
        <img alt="Vue logo" src="../assets/logo.svg" />
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: "home",
    components: {},
};
</script>

<style lang="scss" scoped>
.home {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        height: 30vh;
    }
}
</style>
